import { AnchorProvider } from "@coral-xyz/anchor";
import { useConnection, useWallet } from "@solana/wallet-adapter-react";
import { PublicKey } from "@solana/web3.js";
import { useQuery } from "@tanstack/react-query";

import { VsrClient } from "../../services/governance/vsrClient";

/**
 * For simplicity, it always fetches MNDE realm
 */
export const useVsrClient = () => {
  const { connection } = useConnection();
  const { wallet } = useWallet();
  // TODO: pass as param if needed
  const programId = new PublicKey(
    "VoteMBhDCqGLRgYpp9o7DGyq81KNmwjXQRAHStjtJsS"
  );

  const enabled = Boolean(connection && wallet && programId);
  return useQuery({
    queryKey: enabled ? ["vsrClient"] : undefined,
    queryFn: async () => {
      if (!enabled) throw new Error();
      const options = AnchorProvider.defaultOptions();
      const provider = new AnchorProvider(
        connection,
        // wallet as unknown as Wallet,
        // TODO: use Wallet from @anchor package instead
        wallet as unknown as never,
        options
      );
      return VsrClient.connect(provider, programId);
    },
    cacheTime: 1 * 24 * 60 * 60 * 1000,
    staleTime: 12 * 60 * 60 * 1000,
    enabled,
  });
};
